import EntitySelect from '@/components/app/EntitySelect';
import NoMenuLayout from '@/layouts/GlobalLayout/NoMenuLayout';
import { Row } from 'antd';
import React from 'react';
import {
  CityIcon,
  ConfigurationIcon,
  OperationsIcon,
  MembersIcon,
  AccessControlIcon,
  ParnerIcon,
  CompanyIcon,
  PassengerIcon,
  PlanIcon,
  ServiceIcon,
  SoftwareComponentIcon,
  GlobalICon,
  DiscountIcon,
  BookingIcon,
  SettingIcon,
  NotificationIcon,
  StationIcon,
  CounterIcon,
  RoleIcon,
  TemplateIcon,
  AdvertisingIcon,
} from '@/assets/icons/entities/_';
import { ROW_GUTTER } from '@/config';
import MainContent from '@/layouts/MainContent';
import i18n from '@/helpers/i18n';
import { GlobalUrl } from '@/routers/globalRouters';
import Helmet from 'react-helmet';
import { useTranslation } from 'react-i18next';

const dataOperation = [
  { icon: <MembersIcon />, name: i18n.t('menu.AdminUsers'), url: GlobalUrl.Operations.AdminUsers },
  { icon: <AccessControlIcon />, name: i18n.t('menu.AccessControl'), url: GlobalUrl.Operations.AccessControl },
  { icon: <ParnerIcon />, name: i18n.t('menu.Partners'), url: GlobalUrl.Operations.Partners },
  { icon: <CompanyIcon />, name: i18n.t('menu.Companies'), url: GlobalUrl.Operations.Companies },
  { icon: <PassengerIcon />, name: i18n.t('menu.Passengers'), url: GlobalUrl.Operations.Passengers },
  { icon: <NotificationIcon />, name: i18n.t('menu.Notifications'), url: GlobalUrl.Operations.Notification },
  { icon: <RoleIcon />, name: i18n.t('menu.CompanyRoles'), url: GlobalUrl.Operations.CompanyRole },
];
const dataConfigurations = [
  { icon: <CounterIcon />, name: i18n.t('menu.Registers'), url: GlobalUrl.Configurations.Registers },

  { icon: <ServiceIcon />, name: i18n.t('menu.Services'), url: GlobalUrl.Configurations.Services },
  { icon: <PlanIcon />, name: i18n.t('menu.Plans'), url: GlobalUrl.Configurations.Plans },
  { icon: <StationIcon />, name: i18n.t('menu.Stations'), url: GlobalUrl.Configurations.Stations },
  { icon: <SettingIcon />, name: i18n.t('menu.CommonSetting'), url: GlobalUrl.Configurations.GlobalSettings },

  { icon: <SoftwareComponentIcon />, name: i18n.t('menu.SoftwareComponents'), url: GlobalUrl.Configurations.SoftwareComponents },
  { icon: <CityIcon />, name: i18n.t('menu.CountryRegionCity'), url: GlobalUrl.Configurations.Cities },
  { icon: <TemplateIcon />, name: i18n.t('menu.Templates'), url: GlobalUrl.Configurations.ManageTemplates },
];
const passengerAppConfigurations = [
  { icon: <BookingIcon />, name: i18n.t('menu.Bookings'), url: GlobalUrl.PassengerApp.Bookings },
  { icon: <MembersIcon />, name: i18n.t('menu.PassengerAppUsers'), url: GlobalUrl.PassengerApp.Passengers },

  {
    icon: <AdvertisingIcon />,
    name: i18n.t('menu.Advertising'),
    url: GlobalUrl.PassengerApp.Advertising,
  },
  {
    icon: <DiscountIcon />,
    name: i18n.t('menu.Discounts'),
    url: GlobalUrl.PassengerApp.Discounts,
  },
  {
    icon: <SettingIcon />,
    name: i18n.t('menu.PassengerAppSettings'),
    url: GlobalUrl.PassengerApp.Settings,
  },
];

export default function SelectEntity() {
  const { t } = useTranslation();
  return (
    <NoMenuLayout>
      <Helmet title={t('selectEntityPage_Title')} />
      <MainContent noBackgroundColor>
        <Row gutter={ROW_GUTTER}>
          <EntitySelect
            icon={<OperationsIcon />}
            title={t('selectEntityPage_Operations')}
            subTitle={t('selectEntityPage_Operations_SubTitle')}
            data={dataOperation}
          />
          <EntitySelect
            icon={<ConfigurationIcon />}
            title={t('selectEntityPage_Configurations')}
            subTitle={t('selectEntityPage_Configurations_SubTitle')}
            data={dataConfigurations}
          />
          <EntitySelect
            icon={<GlobalICon />}
            title={t('selectEntityPage_PassengerAppConfigurations')}
            subTitle={t('selectEntityPage_PassengerAppConfiguration_SubTitle')}
            data={passengerAppConfigurations}
          />
        </Row>
      </MainContent>
    </NoMenuLayout>
  );
}
